import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { makeStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@classify/react-core-components/Button';

import { translate } from '@openclassrooms/translations';

import { NAME } from '../../constants/constants';
import * as reduxActions from '../../actions';
import { CONFIRM, ALERT } from '../../modal-types';

const useStyles = makeStyles(
  ({ spacing, palette }) => ({
    title: {
      padding: spacing(3),
    },
    label: {
      color: palette.text.onMain,
    },
  }),
  { classNamePrefix: 'ModalRoot' }
);

const ModalRoot = ({ modalType = null, modalProps = {}, actions = {} }) => {
  const classes = useStyles();

  if (!modalType) {
    return null;
  }

  const { hideModal } = actions;
  let { onAccept, onCancel } = modalProps;

  const { title, body, acceptLabel, cancelLabel, maxWidth, acceptButtonVariant } = modalProps;

  if (!onAccept) {
    onAccept = () => {};
  }

  if (!onCancel) {
    onCancel = () => {};
  }

  return (
    <Dialog
      onClose={hideModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth || false}
      open
    >
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" className={classes.label}>
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {modalType === ALERT && (
          <Button onClick={hideModal} variant="tertiary">
            {translate('global.word.ok')}
          </Button>
        )}
        {modalType === CONFIRM && (
          <>
            <Button
              onClick={() => {
                onCancel();
                hideModal();
              }}
              variant="tertiary"
            >
              {cancelLabel || translate('global.word.cancel')}
            </Button>
            <Button
              onClick={() => {
                onAccept();
                hideModal();
              }}
              variant={acceptButtonVariant || 'tertiary'}
            >
              {acceptLabel || translate('global.word.validate')}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => state[NAME];
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(reduxActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);
